export default __webpack_public_path__ + "static/media/homescreen-rafiki.74a42957.svg";